module.exports = "/_next/static/images/visacard-c756944280c094529c7b9dd0930ddb7f.svg";